module.exports = __webpack_public_path__ + "img/harta_afiliati.762d677b.png";